import * as React from "react";
const SvgFiRrDropDown = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-drop-down_svg__a)">
      <path
        fill="#062147"
        d="M4 18a1 1 0 0 1 1-1h6a1 1 0 1 1 0 2H5a1 1 0 0 1-1-1m1-3h6a1 1 0 1 0 0-2H5a1 1 0 1 0 0 2M24 5v2c0 1.654-1.346 3-3 3h-5v9.5c0 2.481-2.019 4.5-4.5 4.5h-7A4.505 4.505 0 0 1 0 19.5V5c0-2.757 2.243-5 5-5h14c2.757 0 5 2.243 5 5m-10 5H2v9.5C2 20.879 3.122 22 4.5 22h7c1.378 0 2.5-1.121 2.5-2.5zm8-5c0-1.654-1.346-3-3-3H5C3.346 2 2 3.346 2 5v3h19c.551 0 1-.448 1-1zm-2.521-1.5h-4.87a.77.77 0 0 0-.544 1.314l2.435 2.23a.77.77 0 0 0 1.089 0l2.435-2.23c.485-.485.14-1.314-.545-1.314"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-drop-down_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrDropDown;
